<template>
  <Search
    :url="url"
    :title="$lang.searchCenter_execute_case_competency"
    :remove_item="remove_item"
    config="center_execute_case_competency"
    toggleable="true"
    removeModalSize="xl"
    :visibleAdd="false"
    :allowEdit="false"
    :allowRemove="false"
  >
    <template slot="addModal" slot-scope="search">
      <AddCenterExecuteCaseCompetency isModal @modal-end-up="search.close" />
    </template>
    <template v-slot:buttons="prop">
      <b-dropdown-item @click="scoring(prop.itemsData)">
        <span>
          <i class="fa fa-edit fa-lg text-info"></i>
          <strong v-text="$lang.search.scoring_tooltip"></strong>
        </span>
      </b-dropdown-item>
      <b-dropdown-item @click="searchCompetency(prop.itemsData)">
        <span>
          <i class="fa fa-history fa-lg text-warning"></i>
          <strong v-text="$lang.search.view_history_tooltip"></strong>
        </span>
      </b-dropdown-item>
    </template>
  </Search>
</template>

<script>
import Search from "@/components/base/search";
import AddCenterExecuteCaseCompetency from "./addCenterExecuteCaseCompetency";

export default {
  components: { Search, AddCenterExecuteCaseCompetency },
  data() {
    return {
      loadingItem: false,
      url:
        this.$config.api_url +
        this.$config.kanoon.center_execute_case_competency
          .replace("{0}", this.$route.params.center_execute_id)
          .replace("{1}", this.$route.params.id) +
        "?is_enable=1",

      view_history_CenterExecuteCaseCompetency: false,
    };
  },
  methods: {
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    scoring(item) {
      this.$router.push(
        "/ac/center_execute/" +
          item.center_execute_id +
          "/case/" +
          item.case_id +
          "/competency/" +
          item.competency_id +
          "/score"
      );
    },
    remove_item(item) {
      return http
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    closeCenterExecuteCaseCompetencyHistory() {
      this.view_history_CenterExecuteCaseCompetency = false;
      this.$refs.indicator_search.getItems();
      this.case_id = "";
    },
    showCenterExecuteCaseCompetencyHistory(item) {
      this.view_history_CenterExecuteCaseCompetency = true;
    },
  },
  created() {},
};
</script>
